import { Button, FormControl, MenuItem, Select, Tooltip } from '@mui/material'
import React, { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import instance from '@/config/relysiaApi';
import Joi from 'joi';
import { toast } from 'react-toastify';
import randomstring from 'randomstring';

const serviceTypes = ["STANDARD", "DEDICATED"];
const feeTypes = ["FEE_MANAGER", "CLASSIC_MODE"];
const primaryDatabases = ["FIREBASE", "SUPABASE"];
const modes = ["SHARED", "DEDICATED"]


const primaryDatabasePlaceholder = [{
  apiKey: "AIzaSyDBbSW3RDj0xxxxxxmmmmmppppp",
  authDomain: "vaionex-infrastructure-dev.firebaseapp.com",
  databaseURL: "https://vaionex-example-dev-default-rtdb.firebaseio.com",
  projectId: "vaionex-example",
  storageBucket: "vaionex-example.appspot.com",
  messagingSenderId: "4986612345",
  appId: "1:498668493369:web:bbccaaddffgg"
},
{
  "spabaseUrl": "https://aebxxxxxxx.supabase.co",
  "supabaseKey": "hfjhfjfjhjfhf"
}
]


export default function () {
  const [getServiceIdConfig, setServiceIdConfig] = useState({
    projectName: '',
    type: '',
    feeType: '',
    paymailDomain: '',
    feePaymail: null,
    data: null
  })

  async function isValid(data) {
    const schema = Joi.object({
      projectName: Joi.string().required(),
      type: Joi.string().allow("STANDARD", "DEDICATED").required(),
      feeType: Joi.string().allow("FEE_MANAGER", "CLASSIC_MODE").required(),
      paymailDomain: Joi.string().required(),
      feePaymail: Joi.string().allow(null).required(),
      data: Joi.when('type', {
        switch: [
          { is: "STANDARD", then: Joi.object().allow(null) },
          {
            is: "DEDICATED", then: Joi.object({
              primaryDatabase: Joi.string().allow("SUPABASE", "FIREBASE").required(),
              mode: Joi.string().allow("SHARED", "DEDICATED").required(),
              config: Joi.when("primaryDatabase", {
                switch: [
                  {
                    is: "FIREBASE", then: Joi.object({
                      firebase: Joi.object({
                        apiKey: Joi.string().required(),
                        authDomain: Joi.string().required(),
                        projectId: Joi.string().required(),
                        storageBucket: Joi.string().optional(),
                        messagingSenderId: Joi.string().optional(),
                        appId: Joi.string().optional(),
                        measurementId: Joi.string().optional(),
                        databaseURL: Joi.string().optional()
                      }).required()
                    })
                  },
                  {
                    is: "SUPABASE",
                    then: Joi.object({
                      supabase: {
                        supabaseUrl: Joi.string().uri().required(),
                        supabaseKey: Joi.string().required()
                      }
                    })
                  }
                ]
              })
            }).required()
          }
        ]
      })

    })
    await schema.validateAsync(data)
  }

  function resetForm() {
    setServiceIdConfig({
      projectName: '',
      type: '',
      feeType: '',
      paymailDomain: '',
      feePaymail: null,
      data: null
    })
  }

  async function onSubmit() {
    try {
      await isValid(getServiceIdConfig)
      const result = await instance.post("/admin/v2/setup", {
        ...getServiceIdConfig,
      })
      if (result.data.data.id) {
        resetForm()
        toast(`serviceId created successfully !`, { type: "success" })
      } else {
        toast(`failed to create serviceId`, { type: "error" })
      }
    } catch (error) {
      if (error?.message) {
        toast(error.message, { type: "error" })
      } else if (error.response.data.data) {
        toast(error.response.data.data.msg, { type: "error" })
      }
    }
  }



  return (
    <div className="flex bg-black/30 min-h-screen">
      <div
        className="w-1/2 px-24 xl:px-48 py-16 hidden lg:block bg-no-repeat bg-center bg-cover"
        style={{ backgroundImage: 'url("/assets/images/onboarding.png")' }}
      >
        <div className="">
          <h1 className="text-5xl mb-6">Make it your own.</h1>
          <p className="text-xl">
            You can choose between a variety of functions, enable and disable
            user functionalities and endpoints, tailored to your very own
            Application.{' '}
          </p>
        </div>
      </div>
      <div className="w-full min-h-52 py-16 sm:px-24 px-12">
        <h2 className="text-3xl">Get started</h2>
        <p>Let's start configuring your new project!</p>
        <div className='w-8/12 min-h-screen mt-20 flex flex-col justify-evenly items-center'>
          <div className='w-full flex flex-row justify-between items-center'>
            <input className='w-full h-12 rounded-md px-3 py-3 text-black' value={getServiceIdConfig.projectName} placeholder='Project Name' onChange={(e) => setServiceIdConfig((prevState) => ({ ...prevState, projectName: e.target.value }))} />
            <Tooltip title="your project name which you want to have.">
              <InformationCircleIcon className='ml-5' width={24} height={24} />
            </Tooltip>
          </div>
          <div className='w-full flex flex-row justify-between items-center'>
            <input className='w-full h-12 rounded-md px-3 py-3 text-black' placeholder='Paymail Domain' value={getServiceIdConfig.paymailDomain} onChange={(e) => setServiceIdConfig((prevState) => ({ ...prevState, paymailDomain: e.target.value }))} />
            <Tooltip title="The domain name which you want to use as paymail service like if you want get yourname@example.com then you have to add example.com and if you want to use a subdomain like yourname@pay.example.com then add pay.example.com .">
              <InformationCircleIcon className='ml-5' width={24} height={24} />
            </Tooltip>
          </div>

          <div className='w-full flex flex-row justify-between items-center'>
            <FormControl fullWidth className='bg-white rounded-md'>
              <Select
                value={getServiceIdConfig.type}
                onChange={(e) => {
                  setServiceIdConfig((prevState) => (e.target.value === serviceTypes[0] ? { ...prevState, type: e.target.value } : { ...prevState, type: e.target.value, data: { primaryDatabase: "", mode: "", config: {} } }))
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value="">
                  <em>Select Service Type</em>
                </MenuItem>
                {
                  serviceTypes.map((el, index) => (<MenuItem key={index} value={el}>{el}</MenuItem>))
                }
              </Select>
            </FormControl>
            <Tooltip title="We supports two type of services, first one is `STANDARD`, in this you won't be the owner of your user data because you are going to use relysia database by default. second one is `dedicated` in which you will be owner your user data because your are going to use & manage your database.">
              <InformationCircleIcon className='ml-5' width={24} height={24} />
            </Tooltip>
          </div>
          <div className='w-full flex flex-row justify-between items-center'>
            <FormControl fullWidth className='bg-white rounded-md'>
              <Select
                value={getServiceIdConfig.feeType}
                onChange={(e) => {
                  setServiceIdConfig((prevState) => ({ ...prevState, feeType: e.target.value, feePaymail: e.target.value === feeTypes[0] ? randomstring.generate(7) : null }))
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value="">
                  <em>Select Fee Type</em>
                </MenuItem>
                {
                  feeTypes.map((el, index) => (<MenuItem key={index} value={el}>{el}</MenuItem>))
                }
              </Select>
            </FormControl>
            <Tooltip title="In our infrastructure we takes fee in two manars. first one is `FEE_MANAGER` in which you are going manager a fee wallet with relysia so whenever user will make transaction using your serviceId then infrastructure will deduct fee from your fee wallet and second one is `CLASSIC_MODE` in which user will pay their transaction cost.">
              <InformationCircleIcon className='ml-5' width={24} height={24} />
            </Tooltip>
          </div>
          {
            getServiceIdConfig.type === serviceTypes[1] ? <>
              <div className='w-full flex flex-row justify-between items-center'>
                <FormControl fullWidth className='bg-white rounded-md'>
                  <Select
                    value={getServiceIdConfig?.data?.primaryDatabase}
                    onChange={(e) => {
                      setServiceIdConfig((prevState) => ({ ...prevState, data: { ...prevState.data, primaryDatabase: e.target.value } }))
                    }}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem value="">
                      <em>Select Primary database </em>
                    </MenuItem>
                    {
                      primaryDatabases.map((el, index) => (<MenuItem key={index} value={el}>{el}</MenuItem>))
                    }
                  </Select>
                </FormControl>
                <Tooltip title="We supports two database as a primary database, first one is `firebase` and second one is `supabase`. this is going to store your user private information.">
                  <InformationCircleIcon className='ml-5' width={24} height={24} />
                </Tooltip>
              </div>

              <div className='w-full flex flex-row justify-between items-center'>
                <FormControl fullWidth className='bg-white rounded-md'>
                  <Select
                    value={getServiceIdConfig?.data?.mode}
                    onChange={(e) => {
                      setServiceIdConfig((prevState) => ({ ...prevState, data: { ...prevState.data, mode: e.target.value } }))
                    }}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem value="">
                      <em>Select database mode</em>
                    </MenuItem>
                    {
                      modes.map((el, index) => (<MenuItem key={index} value={el}>{el}</MenuItem>))
                    }
                  </Select>
                </FormControl>
                <Tooltip title="We supports two mode for database, first one is `DEDICATED` and second one is `SHARED`. The shared mode is going to store user public information with relysia which is litle bit faster than dedicated mode and The dedicated mode is going to store all user information with your database. we would recommand to use `shared` mode">
                  <InformationCircleIcon className='ml-5' width={24} height={24} />
                </Tooltip>
              </div>

              <div className='w-full flex flex-row justify-between items-center'>
                <textarea className='w-full text-black rounded-md' rows={15} cols={45} placeholder={JSON.stringify(primaryDatabasePlaceholder[getServiceIdConfig.data.primaryDatabase === primaryDatabases[0] ? 0 : 1])} onChange={(e) =>
                  setServiceIdConfig((prevState) => (getServiceIdConfig.data.primaryDatabase === primaryDatabases[0] ? { ...prevState, data: { ...prevState.data, config: { firebase: JSON.parse(e.target.value) } } } : { ...prevState, data: { ...prevState.data, config: { supabase: JSON.parse(e.target.value) } } }))
                }></textarea>
                <Tooltip title="you have to add your primary database configuration as a json object">
                  <InformationCircleIcon className='ml-5' width={24} height={24} />
                </Tooltip>
              </div>
            </> : <></>
          }
          <Button className='px-5 py-3 border border-solid border-white text-white font-bold' onClick={() => onSubmit()

          }>Create now</Button>
        </div>
      </div>
    </div>
  )
}
